// extracted by mini-css-extract-plugin
module.exports = {"bannerTextWidth":"aboutPage_bannerTextWidth__rq5ol","pusherDiv":"aboutPage_pusherDiv__yhEbU"};